import { render } from "./EditInfoService.vue?vue&type=template&id=6f0477ef&scoped=true"
import script from "./EditInfoService.vue?vue&type=script&lang=js"
export * from "./EditInfoService.vue?vue&type=script&lang=js"

import "./EditInfoService.vue?vue&type=style&index=0&id=6f0477ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0477ef"]])

export default __exports__